import { supabase } from '@/lib/supabase';

export const getPartnerOfContractorProject = async (projectId: number) => {
  const { data, error } = await supabase.rpc(
    'get_client_partner_by_contractor_project',
    {
      p_project_id: projectId,
    },
  );

  if (error) {
    throw error;
  }

  return data;
};
